import React from 'react';
import { Modal, Form, Select, Input, Button } from 'antd';

const { TextArea } = Input;
const { Option } = Select;

const RespondRequestModal = ({ 
    visible, 
    onCancel, 
    onSubmit,
    request,
    loading,
}) => {
    const [form] = Form.useForm();

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            await onSubmit({
                requestId: request.id,
                status: values.status,
                reason: values.reason || '',
            });
            form.resetFields();
        } catch (err) {
            console.error("Validation failed:", err);
        }
    };

    return (
        <Modal
            title={
                <span className="text-primary text-lg font-semibold">
                    Respond to Excuse Request
                </span>
            }
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={handleSubmit}
                    loading={loading}
                    className="bg-primary hover:bg-primary_hover"
                >
                    Submit Response
                </Button>,
            ]}
            destroyOnClose
            width={500}
        >
            {request && (
                <div className="mb-4 p-4 bg-gray-50 rounded-lg">
                    <div className="grid grid-cols-2 gap-2 text-sm">
                        <div>
                            <span className="text-gray-600">Employee:</span>
                            <span className="ml-2 font-semibold text-primary">
                                {request.employeeName}
                            </span>
                        </div>
                        <div>
                            <span className="text-gray-600">Excuse:</span>
                            <span className="ml-2 font-semibold text-primary">
                                {request.excuseName}
                            </span>
                        </div>
                        <div>
                            <span className="text-gray-600">Days Requested:</span>
                            <span className="ml-2 font-semibold">{request.daysRequested}</span>
                        </div>
                        <div>
                            <span className="text-gray-600">Period:</span>
                            <span className="ml-2 font-semibold">
                                {new Date(request.startDate).toLocaleDateString()} - {new Date(request.endDate).toLocaleDateString()}
                            </span>
                        </div>
                        {request.reason && (
                            <div className="col-span-2">
                                <span className="text-gray-600">Request Reason:</span>
                                <p className="mt-1 text-gray-700">{request.reason}</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            <Form form={form} layout="vertical">
                <Form.Item
                    name="status"
                    label="Response"
                    rules={[{ required: true, message: 'Please select a response' }]}
                >
                    <Select placeholder="Select response">
                        <Option value={1}>
                            <span className="text-green-600 font-medium">✓ Approve</span>
                        </Option>
                        <Option value={2}>
                            <span className="text-red-600 font-medium">✗ Reject</span>
                        </Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="reason"
                    label="Response Reason (Optional)"
                >
                    <TextArea
                        rows={3}
                        placeholder="Enter reason for your response..."
                        maxLength={300}
                        showCount
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default RespondRequestModal;